import React, { useEffect, useState } from "react";

const diplomacyModulesData = [
  {
    stage: "Postgraduate Certificate (30 ECTS)",

    modules: [
      {
        title: "Foundations of Politics (3 ECTS)",
        description:
          "Explore political science fundamentals, ideologies, & systems, building a strong foundation for advanced governance & policy studies.",
      },
      {
        title: "Practical Politics in Africa (3 ECTS)",
        description:
          "Analyse Africa’s political landscape, focusing on challenges, governance frameworks, & sustainable development.",
      },
      {
        title: "Comparative Political Systems: Learning from the West (3 ECTS)",
        description:
          "Examine Western political systems to identify governance practices applicable to diverse contexts.",
      },
      {
        title: "Cultural Relations & Diplomacy (3 ECTS)",
        description:
          "Study the role of culture in diplomacy & its impact on fostering global understanding & cooperation.",
      },
      {
        title: "Introduction to International Relations (3 ECTS)",
        description:
          "Investigate core international relations theories & concepts, focusing on cooperation, conflict resolution, & global governance.",
      },
      {
        title: "Parliamentary Affairs (3 ECTS)",
        description:
          "Understand parliamentary structures, processes, & governance frameworks, emphasising effective legislative practices.",
      },
      {
        title: "Knowledge, Power, & Politics in Human Science (3 ECTS)",
        description:
          "Critically evaluate how knowledge production shapes political systems & governance globally.",
      },
      {
        title: "Promoting Inclusivity & Sustainable Governance (3 ECTS)",
        description:
          "Develop strategies for inclusive governance & sustainable decision-making aligned with global development goals.",
      },
    ],
  },
  {
    stage: "Postgraduate Diploma (30 ECTS)",

    modules: [
      {
        title: "Introduction to Diplomacy (2.5 ECTS)",
        description:
          "Explore the evolution, principles, & practices of diplomacy in global contexts.",
      },
      {
        title: "International Organisations (2.5 ECTS)",
        description:
          "Analyse the roles & structures of international organisations in promoting global governance & cooperation.",
      },
      {
        title: "Diplomatic Protocol & Practice (2.5 ECTS)",
        description:
          "Master essential diplomatic protocols & etiquette for effective representation in multilateral environments.",
      },
      {
        title: "Global Diplomatic Frameworks (2.5 ECTS)",
        description:
          "Investigate contemporary diplomatic systems & their role in addressing transnational challenges.",
      },
      {
        title: "Foreign Policy Analysis & Implementation (2.5 ECTS)",
        description:
          "Examine the development & execution of foreign policies in complex geopolitical environments.",
      },
      {
        title: "Principles of International Law (2.5 ECTS)",
        description:
          "Study key international legal frameworks governing trade, diplomacy, & conflict resolution.",
      },
      {
        title: "Conflict Resolution & Mediation (2.5 ECTS)",
        description:
          "Develop advanced skills in analysing & mediating international disputes to achieve sustainable outcomes.",
      },
      {
        title: "Modes of Diplomacy in the 21st Century (2.5 ECTS)",
        description:
          "Examine modern diplomatic practices, including public, economic, & cultural diplomacy.",
      },
      {
        title: "Diplomatic Negotiation Techniques (2.5 ECTS)",
        description:
          "Learn strategies for effective negotiation & consensus-building in international settings.",
      },
      {
        title: "Trends & Transformations in World Politics (2.5 ECTS)",
        description:
          "Analyse political trends & their impact on global diplomacy & governance.",
      },
      {
        title: "Science Diplomacy: Innovation & Global Impact (2.5 ECTS)",
        description:
          "Explore how science & technology foster international collaboration & address global challenges.",
      },
    ],
  },
  {
    stage: "Master’s in Diplomacy & International Relations (30 ECTS)",
    modules: [
      {
        title: "Global Diplomatic Concepts & Models (5 ECTS)",
        description:
          "Examine advanced concepts & models of diplomacy, focusing on innovative strategies for leadership in global settings.",
      },
      {
        title: "Economics, Politics, & Society in Africa (5 ECTS)",
        description:
          "Critically analyse Africa’s political economy & its influence on governance & international relations.",
      },
      {
        title: "Economics, Politics, & Society in Europe (5 ECTS)",
        description:
          "Study Europe’s political & economic systems, focusing on historical legacies & governance challenges.",
      },
      {
        title: "Advanced Research Methods in Diplomacy (5 ECTS)",
        description:
          "Develop sophisticated research skills using qualitative & quantitative methods to address key issues in diplomacy & international relations.",
      },
      {
        title: "Dissertation (10 ECTS)",
        description:
          "Conduct original research on a specialised topic, contributing to academic & practical advancements in diplomacy.",
      },
    ],
  },
];

const DiplomacyModules = () => {

  const [activeStages, setActiveStages] = useState([0]);
  const [openModuleIndex, setOpenModuleIndex] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleShowStage = (index) => {
    setActiveStages((prev) => {

      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });


    if (isMobile) {
      setTimeout(() => {
        const stageEl = document.getElementById(`stage-${index}`);
        if (stageEl) {
          stageEl.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };


  const toggleModuleDetails = (stageIndex, modIndex) => {
    setOpenModuleIndex((prev) => ({
      ...prev,
      [stageIndex]: prev[stageIndex] === modIndex ? null : modIndex,
    }));
  };

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="modules">
      <div className="max-w-6xl mx-auto p-3 flex flex-col items-center">
        <h2 className="text-center text-2xl font-bold pb-4 border-b-4 border-sdorange inline-block mx-auto">
          Programme Modules
        </h2>

        <div className="sticky top-16 md:top-44 mt-2 mb-4">
          <div
            className="
      bg-blue-100 border-2 border-blue-500 p-2 rounded-md
      flex flex-col md:flex-row
      space-y-2 md:space-y-0 md:space-x-4
      items-center justify-center
    "
          >
            {diplomacyModulesData.map((stageData, idx) => (
              <button
                key={idx}
                onClick={() => handleShowStage(idx)}
                className="bg-sddarkorange text-white py-1 px-2 rounded text-sm"
              >
                {stageData.stage}
              </button>
            ))}
          </div>
        </div>


        <div
          className={
            isMobile
              ? "space-y-6" 
              : "flex space-x-6 overflow-x-auto" 
          }
        >
          {activeStages.map((stageIndex) => {
            const { stage, modules } = diplomacyModulesData[stageIndex];

            return (
              <div
                key={stageIndex}
                id={`stage-${stageIndex}`}
                className="min-w-[300px] scroll-mt-44 max-w-sm border-2 rounded-md bg-gray-400 bg-opacity-50 border-sdorange p-4"
              >
                <h3 className="text-xl font-semibold mb-2">{stage}</h3>

                {modules.map((mod, modIndex) => {
                  const isOpen = openModuleIndex[stageIndex] === modIndex;
                  return (
                    <div key={modIndex} className="mb-3">
                      <button
                        onClick={() =>
                          toggleModuleDetails(stageIndex, modIndex)
                        }
                        className="flex justify-between items-center w-full px-2 py-1 bg-sdorange rounded text-gray-700 hover:bg-orange-400 hover:text-black"
                      >
                        <div className="flex items-center space-x-2">
                          <img
                            src="/image-fix/academic-programmes/certified-courses/icons/play-circle-svgrepo-com.svg"
                            alt="Play Icon"
                            className="h-4 w-4"
                          />
                          <span className="font-semibold text-sm">
                            {mod.title}
                          </span>
                        </div>
                        <span>
                          {isOpen ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 15l7-7 7 7"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          )}
                        </span>
                      </button>

                      {isOpen && (
                        <div className="mt-2 p-2 bg-sdbodywhite rounded shadow text-sm text-gray-700">
                          <p>{mod.description}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DiplomacyModules;
